module.exports = __webpack_public_path__ + "static/media/october2024-3.c8edd719.webp";